import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Cable } from "lucide-react";

const serviceData = {
  id: "precablage",
  title: "Précâblage",
  description: "Solutions de précâblage informatique et téléphonique",
  icon: Cable,
  image: "/precablage.jpg", // Updated path
  longDescription: [
    "Notre service de précâblage offre des solutions complètes pour l'infrastructure de vos réseaux informatiques et téléphoniques. Nous concevons et installons des systèmes de câblage structuré adaptés à vos besoins.",
    "Nos installations respectent les normes les plus strictes pour garantir des performances optimales et une évolutivité maximale de votre infrastructure réseau.",
  ],
  features: [
    "Câblage structuré catégorie 6A/7",
    "Installation de baies et coffrets",
    "Certification des liaisons",
    "Brassage et identification",
    "Cheminement des câbles",
    "Documentation technique détaillée",
  ],
  benefits: [
    "Infrastructure réseau performante",
    "Solution évolutive et pérenne",
    "Garantie de performance",
    "Installation professionnelle",
    "Support technique dédié",
  ],
};

const Precablage = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default Precablage;
